import { Controller } from "@hotwired/stimulus"
import svgPanZoom from 'svg-pan-zoom'

window.panXs = []
window.panYs = []
window.panZooms = []

export default class extends Controller {
  static values = {
    message: String,
    zoom: Object
  }

  connect() {
    const svgTarget = this.element.querySelector('svg')
    // console.log(this.element.querySelector('svg'))
    console.log('yaw')

    // svgTarget.style.height = this.element.offsetHeight
    // svgTarget.style.height = `${this.element.offsetHeight}px`
    // svgTarget.style.maxHeight = `100%`
    // svgTarget.setAttribute("height", '250px')
    // console.log('this.element', this.element.offsetHeight)
    // console.log('this.element', this.element)
    // console.log('this.svgTarget', svgTarget.style)
    // svgTarget.style.width = this.element.offsetWidth
    // console.log('width', this.element.offsetWidth)
    // svgTarget.classList.add("h-120")
    // svgTarget.classList.add("h-[250px]")
    // svgTarget.setAttribute("height", '250px')

    const zoom = svgPanZoom(svgTarget, {
      center: true,
      zoomScaleSensitivity: 0.3,
      fit: true,
      contain: true,
      onZoom: this.onZoom.bind(this),
      onPan: this.onPan.bind(this)
    })

    if (this.element.id) {
      const panX = localStorage.getItem(`panX-${this.element.id}`)
      const panY = localStorage.getItem(`panY-${this.element.id}`)
      const panZoom = localStorage.getItem(`panZoom-${this.element.id}`)

      if (panX && panY && panZoom) {
        // console.log('yaw', panX, panY, panZoom)
        zoom.zoom(panZoom)
        zoom.pan({ x: panX, y: panY})
      }
      // this.element.scrollTop = localStorage.getItem(`scroll-${this.element.id}`)
    }

    // zoom.zoom(0)
    
    // addEventListener('turbo:load', (event) => {
    //   console.log('a', zoom)
    //   zoom.resize()
    //   zoom.zoom(0)
    //   zoom.fit()
    //   zoom.center()
    //   // zoom.contain()
    //   zoom.updateBBox()
    // })
    // window.addEventListener('turbo:load', function(event) {
    //   zoom.resize();
    //   zoom.fit();
    //   zoom.center();
    // }, true);

    // var cy = window.cy = cytoscape({
    //   container: svgTarget,
    // }
  }

  onZoom(){
    if (this.element.id) {
      const svgTarget = this.element.querySelector('svg')
      const pz = svgPanZoom(svgTarget)
      const zoom = pz.getZoom()
      window.panZooms[this.element.id] = zoom
      // console.log('onZoom', zoom)
    }
  }

  onPan(){
    if (this.element.id) {
      const svgTarget = this.element.querySelector('svg')
      const pz = svgPanZoom(svgTarget)
      const pan = pz.getPan()
      window.panXs[this.element.id] = pan.x
      window.panYs[this.element.id] = pan.y
      // console.log('onPan.x', pan.x)
      // console.log('onPan.y', pan.y)
    }
  }

  disconnect(){
    localStorage.setItem(`panX-${this.element.id}`, window.panXs[this.element.id]);
    localStorage.setItem(`panY-${this.element.id}`, window.panYs[this.element.id]);
    localStorage.setItem(`panZoom-${this.element.id}`, window.panZooms[this.element.id]);
    // console.log('sowat', this.zoomValue)
  }
}